<template>
  <div id="subscription_overview" class="container">

    <back-btn to="/profile" class="ml-3"></back-btn>

    <!-- Welcome modal (shown on payment success) -->
    <b-modal size="xl" ref="my-modal" hide-footer title="Welcome to the iAMconnected Platform">
      <div class="d-block text-center">
        <h5 class="mb-3">To help you get the most from the platform, please take a moment to watch the video tour below</h5>
        <div class="embed-responsive embed-responsive-16by9">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/ZqUaBS8_bgE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <p class="mt-3 text-muted small">If you ever get lost, you can find this video at the bottom of the dashboard.</p>
      </div>
      <b-button variant="success" block @click="hideModal">Okay, let's go!</b-button>
    </b-modal>

    <!-- Admin banner -->
    <b-alert v-if="viewing_user_id !== null" variant="info" show class="mt-3">
      <i class="fas fa-user-shield mr-2"></i>Viewing member: <strong v-text="dashboard.user_name"></strong>
    </b-alert>

    <!-- Payment success banner -->
    <div v-if="page_type === 'success'" class="success-banner mt-3">
      <i class="fas fa-check-circle fa-lg mr-2"></i>
      Payment successful — welcome aboard!
    </div>

    <!-- Loading state -->
    <div v-if="page_loading" class="text-center gold py-5">
      <i class="fas fa-atom fa-spin fa-2x"></i>
    </div>

    <template v-else>
      <!-- Manage Billing Card -->
      <div class="sub-section-card mt-3">
        <div class="sub-section-heading">
          <i class="fas fa-file-invoice-dollar sub-section-icon"></i>
          <span>Billing</span>
        </div>
        <div class="sub-section-body">
          <p class="text-muted small mb-3">
            Manage your payment methods, view invoices, and update your billing information through the Stripe portal.
          </p>
          <a
            :href="manageBillingUrl"
            target="_blank"
            class="btn btn-gold"
          >
            <i class="fas fa-external-link-alt mr-2"></i>Manage Subscription &amp; Billing
          </a>
        </div>
      </div>

      <!-- Active Subscriptions Card -->
      <div class="sub-section-card mt-3">
        <div class="sub-section-heading">
          <i class="fas fa-check-circle sub-section-icon"></i>
          <span>Active Subscriptions</span>
        </div>
        <div class="sub-section-body">
          <ActiveSubscriptions />
        </div>
      </div>

      <!-- Payment History Card -->
      <div class="sub-section-card mt-3">
        <div class="sub-section-heading">
          <i class="fas fa-history sub-section-icon"></i>
          <span>Payment History</span>
        </div>
        <div class="sub-section-body">
          <PaymentHistory />
        </div>
      </div>
		</template>

  </div>
</template>

<script>
import axios from '@/axios';
import BackBtn from '@/components/BackBtn.vue';
import PaymentHistory from '@/components/PaymentHistory.vue';
import ActiveSubscriptions from '@/components/ActiveSubscriptions.vue';
export default {
  name: 'SubscriptionOverview',
  components: { BackBtn, PaymentHistory, ActiveSubscriptions },
  data() {
    return {
      checkoutIsDisabled: true,
      customerEmail: this.$store.state.profile.email,
      dasboard: {},
      page_loading: true,
      publishableKey: null,
      successUrl: window.location.origin + '/payments/subscriptions/success',
      cancelUrl: window.location.origin + '/payments/subscriptions/cancelled',
      manageBillingUrl: process.env.VUE_APP_LOCAL_API + 'payments/manage_billing',
      new_user: null,
      page_type: this.$route.params.page_type,
      section_title: this.$route.meta.title,
      stripe_session_id: null,
      stripe_customer_id: null,
      subscription_active: [],
      subscription_items: [],
      subscription_options: [{ value: null, text: 'Please select an option' }],
      subscription_selected: null,
      viewing_user_id: null,
      userHasSubscription: null,
      challenges: null,
      challenge_selected: null,
      userSubscribedItems: [],
    };
  },
  computed: {},
  methods: {
    checkout() {
      console.log('checkout:');

      this.showLoading();

      let params = new URLSearchParams();
      params.append('token', this.$store.state.session_id);
      params.append('successUrl', this.successUrl);
      params.append('cancelUrl', this.cancelUrl);
      params.append('subscription_selected', this.subscription_selected);

      if (this.stripe_customer_id !== null) {
        params.append('customer_id', this.stripe_customer_id);
      }

      axios({
        url: 'payments/stripeCheckoutSessionCreate',
        params: params,
      })
        .then((response) => {
          if (
            typeof response.data.result.session !== 'undefined' &&
            response.data.result.session !== null
          ) {
            this.stripe_session_id = response.data.result.session;
            this.successUrl = window.location.origin +
              '/payments/subscriptions/success?session_id=' +
              this.stripe_session_id;
            const stripe = window.Stripe(this.publishableKey);
            stripe.redirectToCheckout({ sessionId: this.stripe_session_id })
              .then(function (result) {
                if (result.error) {
                  console.log(result.error.message);
                  this.page_loading = false;
                }
              });

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    load_viewing_users_details() {
      let _this = this;

      if (this.viewing_user_id !== null) {
        console.log('load_viewing_users_details:' + this.viewing_user_id);
        _this.dasboard = {};
        let params = new URLSearchParams();
        params.append('token', _this.$store.state.session_id);
        params.append('user_id', _this.viewing_user_id);

        axios({
          url: _this.$store.state.api_url + 'memberGetProfile',
          params: params,
        })
          .then(function (response) {
            if (response.data.profile !== null) {
              console.log('add to dashboard');
              _this.dashboard = response.data.profile;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
          return true;
        }
      }

      return false;
    },

    sessionDataGet() {
      console.log('sessionDataGet');
      let _this = this;

      let params = new URLSearchParams();
      params.append('token', _this.$store.state.session_id);

      if (this.$route.query.session_id) {
        params.append('session_id', _this.$route.query.session_id);
      }

      axios({
        url: _this.$store.state.api_url + 'payments/sessionDataGet',
        params: params,
      })
        .then(function (response) {
          if (response.data.result.stripe_public_key) {
            _this.publishableKey = response.data.result.stripe_public_key;
          }

          if (response.data.result.stripe_subscription_plans) {
            const entries = Object.values(response.data.result.stripe_subscription_plans);
            for (const product of entries) {
              if (!_this.containsObject(product.product, _this.userSubscribedItems)) {
                var T = { value: product.id, text: product.title };
                _this.subscription_options.push(T);
                console.log("Pushing: " + T.text);
              }

            }
          }

          if (
            response.data.result.stripe_customer_id &&
            response.data.result.stripe_customer_id !== null
          ) {
            _this.stripe_customer_id = response.data.result.stripe_customer_id;
          }

          _this.userHasSubscription = response.data.result.userHasSubscription;
          _this.new_user = response.data.result.new_user;
          _this.subscription_active = response.data.result.subscription_active;

          _this.page_loading = false;

          if (_this.$route.params.page_type === 'success') {
            _this.challengesGet(function () {
              const activeProductId = Array.isArray(_this.subscription_active) && _this.subscription_active[0]
                ? _this.subscription_active[0].product_id
                : null;
              if (activeProductId && _this.challenges) {
                for (const challenge of _this.challenges) {
                  if (challenge.subscription === activeProductId) {
                    _this.challenge_selected = challenge;
                  }
                }
              }
              if (_this.challenge_selected) {
                _this.challengeJoin(_this.challenge_selected);
                _this.$router.push('/programs/' + _this.challenge_selected.id);
              }
            });
          }

        })
        .catch(function (error) {
          console.log(error);
          _this.page_loading = false;
        });
    },

    challengesGet(callback) {
      axios.get(`programs?all=1`)
        .then((response) => {
          if (response.data.status == 1) {
            this.challenges = Object.values(response.data.challenges);
          } else {
            this.challenges = [];
          }
          this.totalRows = this.challenges.length;
          if (typeof callback === 'function') callback();
        })
        .catch(function () {
          console.log('Error: challengesGet.');
          if (typeof callback === 'function') callback();
        });
    },

    challengeJoin(challenge) {
      let _this = this;

      //_this.modal.errors.process = 'Processing...';

      let params = new URLSearchParams();
      params.append('token', _this.$store.state.session_id);
      params.append('status', challenge.status);
      params.append('title', challenge.title);
      params.append('description', challenge.description);
      params.append('video', challenge.video);
      params.append('chat', challenge.chat);
      params.append('subscription', challenge.subscription);
      params.append('id', challenge.id)
      console.log(challenge);

      if (challenge.challenge_leader_selected) {
        const challenge_leader = Object.values(challenge.challenge_leader_selected);
        for (const item of challenge_leader) {
          params.append('challenge_leader[]', item.id);
        }
      }

      if (challenge.challenge_members_selected) {
        const challenge_members = Object.values(challenge.challenge_members_selected);
        for (const item of challenge_members) {
          params.append('challenge_members[]', item.id);
        }
      }
      params.append('challenge_members[]', _this.$store.state.profile.id);

      axios({
        url: _this.$store.state.api_url + 'programJoin',
        params: params,
      })
        .then((response) => {
          //_this.modal.errors.profile = response.data.message;
          if (response.data.status == 1) {
            if (response.data.challenge !== null) {
              this.challenges.find((obj) => {
                if (obj.challenge_leader_user_id === challenge.id) {
                  obj = response.data.challenge;
                }
              });
            }
            this.totalRows = this.challenges.length;
            this.modal.errors.process = "Success! Program updated.";
            this.challengeView(challenge);

          } else {
            //_this.modal.errors.process = response.data.message;
          }
        })
        .catch(function () {});
    },

    showLoading() {
      this.page_loading = true;
    },

    subscriptionItemSet() {
      this.subscription_items = [
        {
          plan: this.subscription_selected,
          quantity: 1,
        },
      ];
    },

    userHasActiveSubscription() {
      console.log('userHasActiveSubscription');
      let _this = this;

      let params = new URLSearchParams();
      params.append('token', _this.$store.state.session_id);

      axios({
        url: 'payments/userHasActiveSubscription_check',
        params: params,
      })
        .then((response) => {
          this.userHasSubscription = response.data.status;

          if (response.data.result.subscription) {
            this.subscription_active.title = response.data.result.subscription.title;
            this.subscription_active.expires = response.data.result.subscription.expires;
            this.subscription_active.cost = response.data.result.subscription.cost;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showModal() {
      this.$refs['my-modal']?.show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
  },

  created() {},

  mounted() {
    this.sessionDataGet();
    if (this.page_type === 'success') {
      this.showModal();
    }
  },
  watch: {
    subscription_selected: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val === null) {
          this.checkoutIsDisabled = true;
        } else {
          this.checkoutIsDisabled = false;
          this.subscriptionItemSet();
        }
      },
    },
  },
};
</script>


<style scoped>
/* ── Success Banner ──────────────────────────────────── */
.success-banner {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
  color: #2e7d32;
  font-weight: 600;
  font-size: 0.95rem;
  box-shadow: 0 2px 10px rgba(46,125,50,0.12);
}

/* ── Section Cards ────────────────────────────────────── */
.sub-section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.06);
  overflow: hidden;
}

.sub-section-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  background: linear-gradient(90deg, rgba(214,182,116,0.12) 0%, rgba(214,182,116,0.03) 100%);
  border-bottom: 1px solid rgba(214,182,116,0.2);
  border-left: 4px solid #d6b674;
  font-weight: 600;
  font-size: 0.92rem;
  color: #444;
  letter-spacing: 0.2px;
}

.sub-section-icon {
  color: #d6b674;
  font-size: 0.95rem;
  width: 18px;
  text-align: center;
}

.sub-section-body {
  padding: 22px 24px;
}

/* ── Buttons ──────────────────────────────────────────── */
.btn-gold {
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  border: none;
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 8px;
  padding: 10px 24px;
  box-shadow: 0 3px 12px rgba(214,182,116,0.4);
  transition: all 0.2s;
  display: inline-block;
  text-decoration: none;
}

.btn-gold:hover {
  box-shadow: 0 5px 16px rgba(214,182,116,0.55);
  transform: translateY(-1px);
  color: #fff;
  text-decoration: none;
}

/* ── Misc ─────────────────────────────────────────────── */
.gold { color: #d6b674; }

/* ── Responsive ───────────────────────────────────────── */
@media (max-width: 600px) {
  .sub-section-body {
    padding: 16px;
  }
}
</style>
